/** @format */

import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "../../css/Navbar.css";

import Logo_Traffy from "../../assets/Logo_Traffy.png";
import Fondue_App_Icon from "../../assets/Fondue_App_Icon.png";
import Bangkok_Icon from "../../assets/Bangkok_Icon.png";
import Line_Icon from "../../assets/Line_Icon.png";

/////////////   Redux  //////////////
import { saveLanguageWeb } from "../store/LanguageSlice";
import { savePageRoute } from "../store/RouteSlice";
import { useSelector, useDispatch } from "react-redux";

export default function NavbarTH(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const globalData = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();
  const [openBurger, setOpenBurger] = useState(false);

  useEffect(() => {
    if (location.pathname.startsWith("/report")) {
      changePage("report");
    } else if (location.pathname.startsWith("/track")) {
      changePage("follow");
    } else {
      changePage("report");
    }
  }, [location.pathname]);

  const changeLang = () => {
    dispatch(saveLanguageWeb(!globalData.language.toggle_language));
  };

  const changePage = (data) => {
    dispatch(savePageRoute(data === "track" ? "follow" : data));
  };

  return (
    <div class="navbar-container">
      <div className="icon_group_left">
        <img
          className="Logo_Traffy"
          src="https://storage.googleapis.com/traffy_public_bucket/attachment/2022-06/b92a4bdb1a981eabe982463edb20b97530cfc25c.png"
          onClick={(event) => {
            event.preventDefault();
            window.open("https://www.traffy.in.th/", "_blank");
          }}
        />
        <img
          className="Logo_Traffy"
          src={Fondue_App_Icon}
          onClick={(event) => {
            event.preventDefault();
            window.open("https://lin.ee/nwxfnHw", "_blank");
          }}
        />
        {/* <img
          className="Logo_Traffy"
          src={Bangkok_Icon}
          onClick={(event) => {
            event.preventDefault();
            window.open("https://landing.traffy.in.th?key=cdTKECqN", "_blank");
          }}
        /> */}
      </div>

      <div
        className={openBurger ? "icon_group_right active" : "icon_group_right"}>
        {/* <a
          className="container-btn-report-line"
          onClick={(event) => {
            event.preventDefault();
            window.open("https://lin.ee/nwxfnHw", "_blank");
          }}>
          <p>แจ้งเหตุผ่าน </p>
          <img className="Line_Icon" src={Line_Icon} />
        </a> */}

        <div className="navigate-section">
          <ul className="menu">
            <p
              onClick={() => navigate("report")}
              className={`menu-item ${
                globalData.pageRoute.pageRoute === "report" ? "active" : ""
              }`}>
              แจ้งเรื่องใหม่
            </p>
            <p
              onClick={() => navigate("track")}
              className={`menu-item ${
                globalData.pageRoute.pageRoute === "follow" ? "active" : ""
              }`}>
              ติดตามความก้าวหน้า
            </p>
          </ul>
        </div>

        <div>
          <label className="switch">
            <input
              type="checkbox"
              checked={globalData.language.toggle_language}
              onChange={changeLang}
            />
            <span className="slider round"></span>
            {globalData.language.toggle_language === false ? (
              <span className="language language-eng">ENG</span>
            ) : (
              <span className="language language-th">TH</span>
            )}
          </label>
        </div>
      </div>

      <div className="menu-icons" onClick={() => setOpenBurger(!openBurger)}>
        <i className={openBurger ? "fas fa-times" : "fas fa-bars"}></i>
      </div>
    </div>
  );
}
